export default __webpack_public_path__ + "static/media/12.3577b67f.jpg";